/**
 * copyright (c) 2015 - 2018, Nordic Semiconductor ASA
 *
 * all rights reserved.
 *
 * redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *
 * 1. redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. redistributions in binary form, except as embedded into a nordic
 *    semiconductor asa integrated circuit in a product or a software update for
 *    such product, must reproduce the above copyright notice, this list of
 *    conditions and the following disclaimer in the documentation and/or other
 *    materials provided with the distribution.
 *
 * 3. neither the name of Nordic Semiconductor ASA nor the names of its
 *    contributors may be used to endorse or promote products derived from this
 *    software without specific prior written permission.
 *
 * 4. this software, with or without modification, must only be used with a
 *    Nordic Semiconductor ASA integrated circuit.
 *
 * 5. any software provided in binary form under this license must not be reverse
 *    engineered, decompiled, modified and/or disassembled.
 *
 * this software is provided by Nordic Semiconductor ASA "as is" and any express
 * or implied warranties, including, but not limited to, the implied warranties
 * of merchantability, noninfringement, and fitness for a particular purpose are
 * disclaimed. in no event shall Nordic Semiconductor ASA or contributors be
 * liable for any direct, indirect, incidental, special, exemplary, or
 * consequential damages (including, but not limited to, procurement of substitute
 * goods or services; loss of use, data, or profits; or business interruption)
 * however caused and on any theory of liability, whether in contract, strict
 * liability, or tort (including negligence or otherwise) arising in any way out
 * of the use of this software, even if advised of the possibility of such damage.
 *
 */

import DfuOperation from '../pc-nrf-dfu-js/src/DfuOperation';
import DfuUpdates from '../pc-nrf-dfu-js/src/DfuUpdatesNoFs';
import DfuTransportSink from '../pc-nrf-dfu-js/src/DfuTransportSink';
import DfuTransportSerial from '../pc-nrf-dfu-js/src/DfuTransportSerial';
import { DfuError, ErrorCode } from '../pc-nrf-dfu-js/src/DfuError';

import DfuTransportWebSerial from './DfuTransportWebSerial';
import DfuTransportHid from "./DfuTransportHid";
import DfuTransportWebHid from "./DfuTransportWebHid";
import GenericTransportWebHid from "./GenericTransportWebHid";

export default {
    DfuOperation,
    DfuUpdates,
    DfuTransportSink,
    DfuTransportSerial,
    DfuTransportWebSerial,
    DfuTransportHid,
    DfuTransportWebHid,
    GenericTransportWebHid,
    DfuError,
    ErrorCode,
};

